
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Preloader from './components/behavior/Preloader';
import { Spinner } from './components/Spinner';
import { languageCodes } from './configs/env';
import ErrorBoundary from './error-handling';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import offlineStore from './store/offlineStore';
import { theme } from './theme';

const initializeApp = async () => {
  // #57003 On Windows 10/11 Flag emojis aren't supported (anymore) therefore we need to add a fallback font
  // Except for FF which brings it's own fallback font
  if (navigator.userAgent.includes('Windows NT ') && !navigator.userAgent.includes(' Firefox/')) {
    document.body.classList.add('use-emoji-fallback');
  }

  await offlineStore.ready();
  const AppModule = await import('./App' /* webpackChunkName: "app", webpackPreload: true */);
  return { AppModule };
};

const app = (
  <ErrorBoundary name="root">
    <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Preloader
            fetcher={initializeApp}
            render={({ loading, data, error }) => {
              if (!loading && !error && data) {
                const { AppModule } = data;
                const App = AppModule.default;
                return <App languages={languageCodes} />;
              }
              // TODO: handle Error!
              return <Spinner />;
            }}
          />
        </ThemeProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

const root = document.getElementById('root');
root && ReactDOM.render(app, root);

// TODO: update `registerServiceWorker.js` to latest cra-version
unregisterServiceWorker();
